
import Vue from 'vue';
import Component from 'vue-class-component';
import TButton from '@/lib/form/button/Button.vue';

@Component({
  name: 'signup-testimonial',
  props: [],
  components: {
    TButton
  }
})
export default class SignupTestimonial extends Vue {
  private activeSlide = 1;
  private slideTimer: any = null;
  private slideTransition = 'slide-right';
  private slideColor = 'green';

  mounted() {
    this.slideTimer = setInterval(() => {
      this.viewSlide();
    }, 5000);
  }

  viewSlide(index?) {
    if (index == undefined) {
      index = this.activeSlide == 3 ? 1 : this.activeSlide + 1;
    } else {
      clearInterval(this.slideTimer);
    }

    this.slideTransition =
      this.activeSlide > index ? 'slide-left' : 'slide-right';

    this.activeSlide = index;
  }
}
